import {
  type Message,
  themes,
} from '@sats-group/ui-lib/react/message/message.types';
import { useEffect } from 'react';
import { JsonDecoder } from 'ts.data.json';

const eventType = 'message-event';

type AnemicMessage = Pick<Message, 'text' | 'theme'>;

const detailDecoder = JsonDecoder.object<AnemicMessage>(
  {
    text: JsonDecoder.string,
    theme: JsonDecoder.optional(
      JsonDecoder.oneOf(
        Object.values(themes).map(theme => JsonDecoder.isExactly(theme)),
        'Theme'
      )
    ),
  },
  'Message'
);

export const sendMessage = (message: AnemicMessage) =>
  window.dispatchEvent(new CustomEvent(eventType, { detail: message }));

export type MessageHandler = (message: AnemicMessage) => void;

export const useMessage = (handleMessage?: MessageHandler) => {
  const _handleMessage: EventListener = event => {
    if (!handleMessage) {
      return;
    }

    if (!(event instanceof CustomEvent)) {
      return;
    }

    const detail = detailDecoder.decode(event.detail);
    if (detail.isOk()) {
      handleMessage(detail.value);
    }
  };

  useEffect(() => {
    window.addEventListener(eventType, _handleMessage);

    return () => {
      window.removeEventListener(eventType, _handleMessage);
    };
  }, []);
};
